import { optionTitle_categories } from './CategoriesOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let CategoriesOption: LazyOption = createLazyOption(
    {
        key: 'mailCategories',
        titleStringKey: optionTitle_categories,
        hideTitleInFullOptions: true,
        searchTermsStringKey: optionTitle_categories,
    },
    lazyFullModule,
    m => m.default
);
export default CategoriesOption;
